import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { 
    doLogin, 
    selectUser, 
    fetchGoogleConfig, 
    selectGoogleConfig, 
    doGoogleLogin,
    fetchFacebookConfig,
    selectFacebookConfig,
    doFacebookLogin,
    fetchRecaptchaConfig,
    selectRecaptchaConfig
} from '../../login/LoginSlice';
import { Link } from "react-router-dom";
import styles from '../styles/Navbar.module.css'
import thickwalletFullLogo from '../../../assets/image/logo/thickWalletFullGreenAlignedLogo.png'
import { FiChevronDown } from "react-icons/fi";
import { HiMiniBars3BottomLeft } from "react-icons/hi2";
import { IoClose } from "react-icons/io5";
import Modal from '../../../components/modal/Modal';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import FacebookLoginButton from '../../../components/auth/FacebookLoginButton';

const Navbar = ({ style = {}, redirect }) => {

    // const [navbarBackground, setNavbarBackground] = useState('rgb(89, 85, 239)');
    // const [textColor, setTextColor] = useState('white');
    // const [hamburgerBtnColor, setHamburgerBtnColor] = useState('white');
    // const [navbarBoxShadow, setNavbarBoxShadow] = useState('none');

    const [showSidebar, setShowSidebar] = useState(false);

    const [showFeaturesOptions, setShowFeaturesOptions] = useState(false);
    const [isModalOpen, setModalOpen] = useState(!!redirect);
    const [showScrollLogin, setShowScrollLogin] = useState(false);

    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector(selectUser);
    const googleConfig = useSelector(selectGoogleConfig);
    const facebookConfig = useSelector(selectFacebookConfig);
    const recaptchaConfig = useSelector(selectRecaptchaConfig);
    //TEMP
    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });

    /**
     * Function to handle form input changes.
     * @param {*} e
     */
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    /**
     * Function to execute reCAPTCHA and get token
     * @param {string} action - The action name for reCAPTCHA
     * @returns {Promise<string|null>} - The reCAPTCHA token or null if not available
     */
    const executeRecaptcha = async (action) => {
        if (!recaptchaConfig?.siteKey || !window.grecaptcha) {
            return null;
        }
        
        try {
            await window.grecaptcha.ready(() => {});
            const token = await window.grecaptcha.execute(recaptchaConfig.siteKey, { action });
            return token;
        } catch (error) {
            console.error('reCAPTCHA execution failed:', error);
            return null;
        }
    };

    const login = async () => {
        // Get reCAPTCHA token before login
        const recaptchaToken = await executeRecaptcha('login');
        
        dispatch(doLogin({
            ...formData,
            recaptchaToken
        }));
    }

    /**
     * Function to handle Google SSO login success
     */
    const handleGoogleSuccess = (credentialResponse) => {
        if (credentialResponse?.credential) {
            dispatch(doGoogleLogin(credentialResponse.credential));
        }
    };

    /**
     * Function to handle Google SSO login error
     */
    const handleGoogleError = () => {
        console.error('Google Sign-In failed');
    };

    /**
     * Function to handle Facebook SSO login success
     */
    const handleFacebookSuccess = (accessToken) => {
        if (accessToken) {
            dispatch(doFacebookLogin(accessToken));
        }
    };

    /**
     * Function to handle Facebook SSO login error
     */
    const handleFacebookError = (error) => {
        console.error('Facebook Sign-In failed:', error);
    };

    const toggleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const closeSidebar = () => {
        setShowSidebar(false);
    };

    const toggleFeaturesAccordion = () => {
        setShowFeaturesOptions(!showFeaturesOptions);
    };

    // const changeBackgroundAndTextOnScroll = () => {
    //     if (window.scrollY > 0) {
    //         setNavbarBackground('rgb(255,255,255)');
    //         setTextColor('black');
    //         // setImageSrc(logo);
    //         setHamburgerBtnColor('black');

    //         setNavbarBoxShadow('0 3px 16px rgba(0, 0, 0, 0.1)');
    //     } else {
    //         setNavbarBackground('rgba(0, 0, 0, 0)');
    //         setTextColor('white');
    //         // setImageSrc(nixvpn2);
    //         setHamburgerBtnColor('white');

    //         setNavbarBoxShadow('none')
    //     }
    // };

    // Function to open the modal
    const openModal = () => {
        setModalOpen(true);
        setShowSidebar(false);
    };

    // Function to close the modal
    const closeModal = () => {
        setModalOpen(false);
    };

    useEffect(() => {
        if (redirect) setModalOpen(true);
    }, [redirect]);

    // Fetch Google, Facebook, and reCAPTCHA config when modal opens
    useEffect(() => {
        if (isModalOpen) {
            dispatch(fetchGoogleConfig());
            dispatch(fetchFacebookConfig());
            dispatch(fetchRecaptchaConfig());
        }
    }, [isModalOpen, dispatch]);

    // useEffect(() => {
    //     window.addEventListener('scroll', changeBackgroundAndTextOnScroll);

    //     // Initial call to set the text color based on the initial window size
    //     changeBackgroundAndTextOnScroll();
    //     return () => {
    //         window.removeEventListener('scroll', changeBackgroundAndTextOnScroll);
    //     };
    // }, []);

    useEffect(() => {
        console.log("user changed in navbar:", user);
        if (user && Object.keys(user).length) {
            history.push('/home');
        }
    }, [user, history]);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 500) {
                setShowScrollLogin(true);
            } else {
                setShowScrollLogin(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div>
            <section className={styles.navbar_container} style={style}>
                <div className={styles.navbar_wrapper}>
                    <div className={styles.navbar_logo}>
                        <div className={styles.btn_logo_wrapper}>
                            <button className={`${styles.hamburger_btn} ${showSidebar ? styles.active : ''}`}
                                onClick={toggleSidebar}>
                                <HiMiniBars3BottomLeft />
                            </button>
                            <a href="#bannerSection">
                                <img src={thickwalletFullLogo} alt="" style={{ maxWidth: "70%", height: "auto" }} />
                            </a>
                        </div>

                        <button
                            className={`${styles.scroll_login_btn} ${showScrollLogin ? styles.show : ""}`}
                            onClick={openModal}
                        >
                            LOGIN
                        </button>
                    </div>

                    <ul className={styles.navbar_options}>
                        <li>
                            <a href="#bannerSection">
                                Home</a>

                        </li>
                        <li className={styles.features_dropdown}>
                            <div className={styles.nav_feature_option}>
                                <p>Features</p>
                                <span><FiChevronDown /></span>
                            </div>
                            <ul className={styles.features_dropdown_content}>
                                <li><a href="#featureSection" >
                                    Discover Dips</a>
                                </li>
                                <li><a href="#featureSection" >
                                    Track Trends</a>
                                </li>
                                <li><a href="#featureSection" >
                                    Stock 360</a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a href="#pricingSection" >
                                Pricing</a>
                        </li>
                        <li>
                            <a href="#footerSection" >
                                Contact Us</a>
                        </li>
                    </ul>

                    <button className={styles.login_btn} onClick={openModal} id="mob-login">LOGIN</button>

                    <Modal
                        isOpen={isModalOpen}
                        onClose={closeModal}
                    >
                        <div className={styles.login_form_container}>
                            <div className={styles.form_input_wrapper}>
                                <label htmlFor="modal-email">Email</label>
                                <input 
                                    type="text" 
                                    id="modal-email" 
                                    name="email" 
                                    value={formData.email} 
                                    onChange={handleChange}
                                    aria-label="Email address"
                                />
                            </div>
                            <div className={styles.form_input_wrapper}>
                                <label htmlFor="modal-password">Password</label>
                                <input 
                                    type="password" 
                                    id="modal-password" 
                                    name="password" 
                                    value={formData.password} 
                                    onChange={handleChange}
                                    aria-label="Password"
                                />
                            </div>
                            <button disabled={!formData.email || !formData.password} onClick={login}>Login</button>

                            {(googleConfig?.clientId || facebookConfig?.appId) && (
                                <div className={styles.divider}>
                                    <span>or</span>
                                </div>
                            )}

                            {googleConfig?.clientId && (
                                <div className={styles.google_signin_wrapper}>
                                    <GoogleOAuthProvider clientId={googleConfig.clientId}>
                                        <GoogleLogin
                                            onSuccess={handleGoogleSuccess}
                                            onError={handleGoogleError}
                                            text="signin_with"
                                            shape="rectangular"
                                            width="100%"
                                        />
                                    </GoogleOAuthProvider>
                                </div>
                            )}

                            {facebookConfig?.appId && (
                                <div className={styles.facebook_signin_wrapper}>
                                    <FacebookLoginButton
                                        appId={facebookConfig.appId}
                                        onSuccess={handleFacebookSuccess}
                                        onError={handleFacebookError}
                                        text="signin_with"
                                    />
                                </div>
                            )}
                        </div>
                    </Modal>

                    <div className={`${styles.nav_sidebar} ${showSidebar ? styles.active : ''}`}>
                        <div className={styles.close_section}>
                            <span></span>
                            <button onClick={closeSidebar}><IoClose /></button>
                        </div>

                        <ul className={styles.sidebar_options}>
                            <Link>
                                <li>Home</li>
                            </Link>
                            <li className={styles.features_accordion_wrapper}>
                                <div className={`${styles.features_accordion} ${showFeaturesOptions ? styles.accordion_active : ''}`} >
                                    <div onClick={toggleFeaturesAccordion} className={styles.features_accordion_option}>
                                        <span>Features</span>
                                        <FiChevronDown />
                                    </div>
                                    <div className={styles.features_sub_options}>
                                        <Link to={''}>Discover Dips</Link>
                                        <Link to={''}>Track Trends</Link>
                                        <Link to={''}>Stock 360</Link>
                                    </div>
                                </div>
                            </li>
                            <Link>
                                <li>Pricing</li>
                            </Link>
                            <Link>
                                <li>About Us</li>
                            </Link>
                            <Link>
                                <li>Contact Us</li>
                            </Link>

                            <button id='mob-log' className={styles.sidebar_login_btn} onClick={openModal}>LOGIN</button>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Navbar
